import EditorVM from './editor-vm';
export default {
  init: function () {
    console.log('Initializing AdminSiteAlertEditor');
    const alertData = $('#site_alert_json').val();

    const validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    const $ele = document.getElementById('editor-container');
    ko.applyBindingsWithValidation(new EditorVM(alertData, $ele), $ele, validationOptions);
  }
};

